import { FETCH_AUTOMATION_TRIGGER_SUCCESS, FETCH_STAGES_REQUEST, FETCH_STAGES_SUCCESS } from './stagesTypes';

const initialState = {
  stages: [],
  isLoading: false,
  stageTriggers: [],
};

const stagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STAGES_REQUEST:
      return { ...state, isLoading: true };
    case FETCH_STAGES_SUCCESS:
      return {
        ...state,
        stages: action.payload,
        isLoading: false,
      };
    case FETCH_AUTOMATION_TRIGGER_SUCCESS:
      return {
        ...state,
        stageTriggers: action.payload,
      };
    default:
      return { ...state };
  }
};

export default stagesReducer;
